import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class BlogService {
    private blogUrl = `${environment.apiUrl}/posts`;

    constructor(private http: HttpClient) { }

    getBlogs(page: number = 1, per_page: number): Observable<any> {
        return this.http.get<any>(`${this.blogUrl}?status=publish&page=${page}&per_page=${per_page}`);
    }

    getBlogDetails(slug: string): Observable<any> {
        return this.http.get<any>(`${this.blogUrl}/post/${slug}`);
    }
}
